import { Link, ContentTypeRender } from "nystem-components";
import app from "nystem";

const ViewLinkFields = ({ model, value, path, view }) => {
  const { className, contentType, view: toView, add, addId, item } = model;

  let href = `/${contentType}/${toView}`;
  if (addId && value) href += `/${value._id}`;

  return (
    <Link
      to={app.insertVal((add || "") + href, view)}
      className={className}
      addSearch={model.addSearch}
    >
      <ContentTypeRender path={path} items={item} />
    </Link>
  );
};

export default ViewLinkFields;
